import { jsx as _jsx } from "react/jsx-runtime";
import { Button, CircularProgress } from "@mui/material";
/**
 * Export button for the Employee Performance pages: same look as the shared ExportButton, but with a spinner while
 * exporting and a neutral disabled state (the shared one only greys out, and App.css paints every disabled
 * MUI primary button pink).
 */
export default function ExportLoadingButton({ loading, onClick }) {
    return (_jsx(Button, { variant: "outlined", disabled: loading, disableFocusRipple: true, onClick: onClick, startIcon: loading ? _jsx(CircularProgress, { size: 16, thickness: 5, sx: { color: "#667085" } }) : _jsx("img", { src: "/assets/export.svg", alt: "" }), className: "all-Font-Sizes-12", sx: {
            fontSize: "13px !important", color: "#181D27", borderColor: "#D0D5DD", textTransform: "none",
            fontWeight: 500, borderRadius: "8px", height: "36px", px: 2, gap: 1,
            "&:hover, &.Mui-focusVisible": { bgcolor: "#F9FAFB", borderColor: "#D0D5DD" },
            // "&&" beats App.css's global "body .MuiButton-colorPrimary.Mui-disabled" (pink fill).
            "&&.Mui-disabled": { color: "#667085", borderColor: "#E9EAEB", backgroundColor: "#FAFAFA", cursor: "progress", pointerEvents: "auto" },
        }, children: loading ? "Exporting..." : "Export" }));
}
